"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "pb-2.5 font-bold em88:pt-2.5" };
const _hoisted_2 = { key: 0 };
const vue_i18n_1 = require("vue-i18n");
const use_most_suggested_request_1 = __importDefault(require("@/SearchApp/composables/use-most-suggested-request"));
const TypeAheadItem_vue_1 = __importDefault(require("./TypeAheadItem.vue"));
const use_search_1 = __importStar(require("@/SearchApp/composables/use-search"));
const dataLayer_1 = require("@/SearchApp/services/dataLayer");
exports.default = (0, vue_1.defineComponent)({
    __name: 'FindingsMostSuggested',
    setup(__props) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const { resetSearch } = (0, use_search_1.default)();
        const { mostSuggestedItems, hasMostSuggestedItems } = (0, use_most_suggested_request_1.default)();
        const routeToSearchResults = (event) => {
            window.ocmOrchestrator && window.ocmOrchestrator.spaNavigateUrl(event);
        };
        const onClick = (term, event) => {
            (0, dataLayer_1.tr_searchEvent)({ searchterm: term, type: "suggestion" });
            routeToSearchResults(event);
            resetSearch();
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, (0, vue_2.toDisplayString)((0, vue_2.unref)(mostSuggestedItems).headline), 1),
                (!(0, vue_2.unref)(hasMostSuggestedItems))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.loading")), 1))
                    : ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, (0, vue_2.renderList)((0, vue_2.unref)(mostSuggestedItems).mostSearchItems, (item, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TypeAheadItem_vue_1.default, {
                            key: `mostSuggested-${index}`,
                            "item-text": item.linkName,
                            "is-active": index === (0, vue_2.unref)(use_search_1.focusedTypeAheadIndex),
                            target: !item.sameWindow ? '_blank' : undefined,
                            href: item.url,
                            onClick: ($event) => (onClick(item.linkName, $event))
                        }, null, 8, ["item-text", "is-active", "target", "href", "onClick"]));
                    }), 128))
            ], 64));
        };
    }
});
